import { createCrudActions } from '../utils/crudGenerator';
import { axios } from '../connection/ConnectionHandler';

const getRelationId = (value) => value?._id ?? value;

const formatContainers = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => {
        const zoneDetails = item.zone && typeof item.zone === "object" ? item.zone : null;
        const establishmentDetails = item.establishment && typeof item.establishment === "object"
            ? item.establishment
            : null;

        return {
            ...item,
            zone: zoneDetails?._id ?? item.zone,
            establishment: establishmentDetails?._id ?? item.establishment,
            zoneDetails,
            establishmentDetails,
            label: `${item.number}`,
            value: item._id,
        };
    };

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchContainers,
    create: createContainer,
    update: updateContainer,
    delete: deleteContainers
} = createCrudActions('CONTAINER', "Contenedor", formatContainers);

export const correctContainerZone = (container, zoneId) => async () => {
    const containerData = {
        _id: container._id,
        number: container.number,
        weight: container.weight,
        tarePerDiner: container.tarePerDiner,
        active: container.active !== false && container.active !== "false",
        zone: zoneId,
        establishment: getRelationId(container.establishment),
        product: getRelationId(container.product),
    };

    if (container.rfid !== undefined) {
        containerData.rfid = container.rfid;
    }

    try {
        const response = await axios.put(`container/${container._id}`, containerData);
        return typeof response === "number" ? response : response.status;
    } catch (error) {
        return error?.response?.status ?? 0;
    }
};
